import { tierFor } from "@/lib/tiers";

// Simple colored ring around a circular avatar/logo. Ring color reflects the thank tier.
// (The wavy "seal" graphic in SealPortal.jsx is kept for possible future use.)
export default function TierPortal({ count = 0, size = 40, ringW = 3, gap = 2, className = "", testid = "tier-portal", children }) {
    const t = tierFor(count);
    const n = Number(count) || 0;
    return (
        <span
            data-testid={testid}
            title={`${t.name} · ${n.toLocaleString()} thanks`}
            className={`relative inline-flex items-center justify-center rounded-full shrink-0 ${className}`}
            style={{ padding: gap, boxShadow: `0 0 0 ${ringW}px ${t.color}` }}
        >
            <span
                className="rounded-full overflow-hidden inline-flex items-center justify-center bg-[#0f0f0f]"
                style={{ width: size, height: size }}
            >
                {children}
            </span>
        </span>
    );
}
